import logo from '../assets/images/logo.png';


// languages
// import assamese from "../assets/images/languages/Assamese.png";


let images = {
    logo
}

export default images